import PropTypes from 'prop-types';
import { graphql, useFragment } from 'react-relay';

// components
import { SbSharedRefineMenuMultiSelectSearch } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectSearch.tsx';

const viewerFragment = graphql`
    fragment SbSharedRefineMenuFilterCreator_viewer on Viewer {
        ...SbSharedRefineMenuMultiSelectSearch_viewer
    }
`;
const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterCreator_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuMultiSelectSearch_itemSearch
    }
`;

export const SbSharedRefineMenuFilterCreator = ({
    viewer: viewerRef,
    itemSearch: itemSearchRef,
    collapsedItemCount,
    filterName,
    values,
    showSearchBar,
    trackingOptions,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    return (
        <SbSharedRefineMenuMultiSelectSearch
            viewer={viewer}
            itemSearch={itemSearch}
            filterName={filterName}
            collapsedItemCount={collapsedItemCount}
            values={values}
            showSearchBar={showSearchBar}
            trackingOptions={trackingOptions}
        />
    );
};

SbSharedRefineMenuFilterCreator.propTypes = {
    viewer: PropTypes.object.isRequired,
    itemSearch: PropTypes.object.isRequired,
    filterName: PropTypes.string.isRequired,
    collapsedItemCount: PropTypes.number,
    values: PropTypes.array.isRequired,
    showSearchBar: PropTypes.bool,
    trackingOptions: PropTypes.object,
};
